import { render, staticRenderFns } from "./PhotoPayInfo.vue?vue&type=template&id=4f165b02"
import script from "./PhotoPayInfo.vue?vue&type=script&lang=js"
export * from "./PhotoPayInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports